import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertStringToDate'
})
export class LegadoConvertStringToDatePipe implements PipeTransform {

  transform(value: string | Date | undefined, includeTime?: boolean): unknown {

    if (value) {
      const date = value instanceof Date ? value : new Date(value);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear());
      const hour = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return includeTime ? `${day}/${month}/${year} - ${hour}h${minutes}m${seconds}s` : `${day}/${month}/${year}`;
    }

    return null;
  }

}

